import React from "react";
import { Container } from "@mui/material";
import AppRouter from "./routes/AppRouter";
import Navbar from "./components/Navbar";
import PasswordProtection from "./components/PasswordProtection";

function App() {
    return (
        <PasswordProtection>
            <Container maxWidth="lg">
                <Navbar />
                <AppRouter />
            </Container>
        </PasswordProtection>
    );
}

export default App;
